var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNew3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 126,
    viewBox: "0 0 109 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 54.238,
    cy: 54.238,
    r: 54.238,
    fill: "#D9D9D9",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9047 43.9043H43.9306M28.4047 36.671L28.4047 48.2301C28.4047 49.4938 28.4047 50.1257 28.5475 50.7203C28.674 51.2475 28.8828 51.7515 29.1661 52.2138C29.4856 52.7352 29.9324 53.182 30.826 54.0755L50.6366 73.8862C53.7057 76.9553 55.2403 78.4899 57.0098 79.0648C58.5664 79.5706 60.2431 79.5706 61.7996 79.0648C63.5691 78.4899 65.1037 76.9553 68.1729 73.8862L73.8866 68.1724C76.9557 65.1033 78.4903 63.5687 79.0652 61.7992C79.571 60.2426 79.571 58.5659 79.0652 57.0094C78.4903 55.2399 76.9557 53.7053 73.8866 50.6362L54.076 30.8255C53.1824 29.932 52.7356 29.4852 52.2142 29.1657C51.7519 28.8824 51.2479 28.6736 50.7208 28.5471C50.1261 28.4043 49.4943 28.4043 48.2306 28.4043L36.6714 28.4043C33.7778 28.4043 32.331 28.4043 31.2258 28.9674C30.2536 29.4628 29.4632 30.2532 28.9679 31.2253C28.4047 32.3306 28.4047 33.7774 28.4047 36.671ZM45.1964 43.9043C45.1964 44.6177 44.6181 45.196 43.9047 45.196C43.1914 45.196 42.6131 44.6177 42.6131 43.9043C42.6131 43.1909 43.1914 42.6126 43.9047 42.6126C44.6181 42.6126 45.1964 43.1909 45.1964 43.9043Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12318_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0116 121.476L54.238 120.476L93.4644 121.476V122.425L54.238 123.425L15.0116 122.425V121.476Z",
    fill: "url(#paint0_linear_12318_347)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12318_347",
    x: 13.0116,
    y: 118.476,
    width: 82.4528,
    height: 6.94922,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12318_347"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12318_347",
    x1: 15.0116,
    y1: 121.951,
    x2: 93.4644,
    y2: 121.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0528846,
    stopColor: "#06378F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#85D4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932692,
    stopColor: "#06378F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew3);
export default __webpack_public_path__ + "static/media/new-3.ea64a57cac589be38fa691a96ab920bd.svg";
export { ForwardRef as ReactComponent };